﻿(function () {
    "use strict";

    var app = angular.module("app");

    app.filter("toDollars", function () {
        return function (value) {
            if (typeof value === "undefined" || value === null || isNaN(value))
                return null;

            return Math.round(value) * 0.01;
        }
    });

})();
